import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=bfbf2caa&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=bfbf2caa&lang=scss&scoped=true"
import style1 from "./collect.vue?vue&type=style&index=1&id=bfbf2caa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbf2caa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfbf2caa')) {
      api.createRecord('bfbf2caa', component.options)
    } else {
      api.reload('bfbf2caa', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=bfbf2caa&scoped=true", function () {
      api.rerender('bfbf2caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-query/components-cool/collect.vue"
export default component.exports